import { HttpClient } from '../shared/http-client';
import 'rxjs/add/operator/map';
var ParametroService = /** @class */ (function () {
    function ParametroService(httpClient) {
        this.httpClient = httpClient;
    }
    ParametroService.prototype.listado = function () {
        return this.httpClient.get("/parametros/")
            .map(function (response) {
            return response.json();
        });
    };
    ParametroService.prototype.actualizar = function (parametros) {
        return this.httpClient.put('/parametros/', parametros);
    };
    ParametroService.ctorParameters = function () { return [{ type: HttpClient }]; };
    return ParametroService;
}());
export { ParametroService };
//# sourceMappingURL=parametro.service.js.map


// WEBPACK FOOTER //
// parametro.service.js